import { cimaxxxxApiSlice } from "../Cimaxxxx/cimaxxxxApiSlice";

export const puertosxApiSlice = cimaxxxxApiSlice.injectEndpoints({
  overrideExisting: true,
  endpoints: (builder) => ({
    // Puertos activos de un pais (CIPO0170), ej. CO para los de Colombia
    getPuertoByPais: builder.query({
      query: (filter) => ({
        url: `Registxx/Tracvuce/getPuertoEmbarqueByPais/${filter.PAIIDXXX}`,
        method: "GET",
        headers: {
          Modulecima: "Registxx",
        },
      }),
      // son pocos registros y no cambian durante la sesion
      keepUnusedDataFor: 3600,
    }),
  }),
});

export const { useGetPuertoByPaisQuery } = puertosxApiSlice;
